import { ObservableFromFetch } from "../ObservableFromFetch"
import Role from "./Model/Role"

export default function GetAdditionalRoles() {
  return ObservableFromFetch<Role[]>("FFOrderUserInvitation/GetAdditionalRole")
}
